import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { DevTools } from '../../containers/DevTools';

export const AdminDevToolsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<DevTools />
		</AdminDashboardPageLayout>
	);
};
